import { Div } from '@/domains/core/tamagoshiTailwind/components/Typography/Typography';

export const loyaltyCardContentFormatter = <T,>(otherFields: T) => ({
  title: (chunks: (string | JSX.Element)[]) => (
    <Div scale="title3" key="title">
      {chunks}
    </Div>
  ),
  description: (chunks: (string | JSX.Element)[]) => (
    <Div scale="body2" key="description">
      {chunks}
    </Div>
  ),
  ...otherFields,
});
